import { render } from "./App.vue?vue&type=template&id=90f7aa90"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=90f7aa90&lang=css"
script.render = render

export default script